export default __webpack_public_path__ + "static/media/txt_training.8208c3ae.svg";